<div class="checkout-vip-process">
  <div class="header padding-16">
    <pdq-button
      (onClick)="cancel()"
      iconColor="var(--on-surface-light)"
      variant="light"
      icon="side_left_arrow"></pdq-button>
    <pdq-heading element="h4">Priority processing</pdq-heading>
  </div>

  <div class="content">
    <form [formGroup]="formGroup">
      <div class="section padding-16 gap-16">
        <span>Let your customer add gift note text</span>

        <pdq-input
          formControlName="title"
          label="Title"
          placeholder="Priority processing"
          [invalid]="formGroup.controls.title.errors?.required"
          [invalidMsg]="formGroup.controls.title.errors?.required ? 'Title is required' : ''"></pdq-input>
        <pdq-textarea
          [control]="formGroup.controls?.description"
          label="Description text"
          placeholder="Get special service for your order"></pdq-textarea>
        <div class="upsell-section gap-16">
          <pdq-input-arrows
            widthSize="large"
            precision="2"
            min="0"
            formControlName="upsellRate"
            label="Upsell rate"
            symbol="$"
            placeholder="6.00"
            [invalid]="formGroup.controls.upsellRate.errors?.required"
            [invalidMsg]="
              formGroup.controls.upsellRate.errors?.required ? 'Upsell rate is required' : ''
            "></pdq-input-arrows>
          <pdq-input-arrows
            widthSize="large"
            symbol="%"
            min="0"
            formControlName="discount"
            label="Discount"
            placeholder="20"
            max="100"></pdq-input-arrows>
        </div>
      </div>

      <div class="section padding-16 gap-16">
        <pdq-heading element="h6">PDQ Priority preferences</pdq-heading>
        <span>Define how this upsell effects order in PDQ system</span>
        <div fxFlex="1">
          <pdq-checkbox
            formControlName="prioritizeOrder"
            label="Add order tag and pin order to top in PDQ workflow"></pdq-checkbox>
          <pdq-tag variant="quaternary" mode="rect">Priority Order</pdq-tag>
        </div>
      </div>
    </form>
  </div>

  <div class="footer padding-16">
    <div class="actions">
      <pdq-button label="Cancel" (onClick)="cancel()" variant="light"></pdq-button>
      <pdq-button
        label="Save"
        variant="primary"
        (onClick)="saveValues(formGroup.value)"
        [disabled]="formGroup.invalid"
        [loading]="loading$ | async"></pdq-button>
    </div>
  </div>
</div>
